module.exports = __webpack_public_path__ + "img/news_app.88f1e920.jpg";